import React from 'react';
import { ComponentsProps, ComponentsOverrides, ComponentsVariants, formLabelClasses, Theme } from '@mui/material';
import { CloseIcon, Stack, Typography } from '../../../components';
import { baseTheme } from '../../base-theme';

const ErrorIconClass = 'Mui-error-icon';

export const MuiFormHelperText: {
    defaultProps?: ComponentsProps['MuiFormHelperText'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormHelperText'];
    variants?: ComponentsVariants['MuiFormHelperText'];
} = {
    defaultProps: {
        // eslint-disable-next-line
        // @ts-ignore
        component: (props) => (
            <Stack alignItems="center" direction="row" spacing={baseTheme.tokens.spacing.xxs}>
                <CloseIcon className={[props.className, ErrorIconClass].join(' ')} />
                <Typography {...props} component={typeof props.children === 'string' ? 'p' : 'div'} width="100%" />
            </Stack>
        ),
    },
    styleOverrides: {
        root: (props) => [
            props.theme.typography.helperText,
            {
                marginLeft: 0,
                marginRight: 0,
                [`&.${ErrorIconClass}`]: {
                    display: 'none',
                },
                [`&.${formLabelClasses.error}.${ErrorIconClass}`]: {
                    margin: 0,
                    display: 'block',
                },
            },
        ],
    },
};
